import { jsx } from "react/jsx-runtime";
import styles from "./Tag.module.scss.js";
function Tag(props) {
  return /* @__PURE__ */ jsx("span", { className: styles.root, children: props.text });
}
export {
  Tag
};
